import { useApiClient } from '~/api-client';
import {
    ApiResultUpdateDispositionsResponse,
    DispositionsForm,
    DispositionsFormType,
    DispositionResource,
    ReleaseUnitsRequest,
} from '@mark43/cad-api';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios-cad-nx';

export function useUpdateDispositionMutation({
    actingTransitioner,
    unitIds,
    onMutationSuccess,
}: {
    actingTransitioner?: ReleaseUnitsRequest['actingTransitioner'];
    unitIds?: number[];
    onMutationSuccess?: (data: AxiosResponse<ApiResultUpdateDispositionsResponse>) => void;
}) {
    const apiClient = useApiClient();
    const mutation = useMutation(
        (dispositionsFormValues: DispositionsFormType) => {
            const releaseUnitsRequest: ReleaseUnitsRequest | undefined =
                actingTransitioner && unitIds
                    ? {
                          actingTransitioner,
                          unitIds,
                      }
                    : undefined;
            return apiClient.request<DispositionResource.UpdateDispositions>({
                method: 'POST',
                url: 'disposition/update',
                data: {
                    form: dispositionsFormValues as DispositionsForm,
                    releaseUnitsRequest,
                },
            });
        },
        {
            onSuccess(data) {
                onMutationSuccess?.(data);
            },
        }
    );
    return mutation;
}
